var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "tui-grid/dist/tui-grid.css";
import { Chip, ChipDelete, IconButton, Input, Menu, } from "@mui/joy";
import { useSaveSearchHistoryMutation, useSearchBasicModulesQuery, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useNavigate, useParams } from "react-router-dom";
import List from "./list";
import { faHistory, faSearch } from "@fortawesome/pro-solid-svg-icons";
import History from "./history";
import { useColorIcons } from "@/utils/themes/hooks";
import moment from "moment";
export default function SearchList(_a) {
    var _this = this;
    var _b, _c, _d;
    var widget = _a.widget, onChange = _a.onChange;
    var searchParam = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.searchParam;
    var _e = useState(searchParam), value = _e[0], setValue = _e[1];
    var menuRef = useRef(null);
    var _f = useState([]), chips = _f[0], setChips = _f[1];
    var _g = useState([]), recentSearch = _g[0], setRecentSearch = _g[1];
    var _h = useState(""), searchTrigger = _h[0], setSearchTrigger = _h[1];
    var colorIcons = useColorIcons();
    var _j = useState(null), anchorEl = _j[0], setAnchorEl = _j[1];
    var isOpenHistory = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(isOpenHistory ? null : event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var type = useParams().type;
    var searchQuery = useMemo(function () {
        return (value
            .split(" ")
            .filter(function (word) { return !word.startsWith("module:"); })
            .join(" ") || "");
    }, [value]);
    var _k = useSearchBasicModulesQuery({ params: { query_string: searchTrigger } }, { skip: !searchTrigger.trim() }), searchBasicModules = _k.data, isLoading = _k.isLoading, isFetching = _k.isFetching;
    var _l = useSaveSearchHistoryMutation(), saveSearchHistory = _l[0], resultSearchHistory = _l[1].data;
    var t = useTranslation(["common", "Administration"]).t;
    var handleSearch = function () {
        setValue(value);
    };
    useEffect(function () {
        handleSearch();
    }, [value, (_c = searchBasicModules === null || searchBasicModules === void 0 ? void 0 : searchBasicModules.data.results) === null || _c === void 0 ? void 0 : _c.hits]);
    var elementCountPerPage = "scroll";
    var defaultElementPerPage = 10;
    var _m = useState(defaultElementPerPage), elementPerPage = _m[0], setElementPerPage = _m[1];
    var _o = useState(0), totalResultCount = _o[0], setTotalResultCount = _o[1];
    var _p = useState([]), record = _p[0], setRecord = _p[1];
    var navigate = useNavigate();
    var loadResultSearch = function () { return __awaiter(_this, void 0, void 0, function () {
        var cleanedQuery, dataModule, data, foundModules_1, allChipsExist, error_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    cleanedQuery = value
                        .split(" ")
                        .filter(function (word) { return !word.startsWith("module:"); })
                        .join(" ");
                    setSearchTrigger(cleanedQuery);
                    setRecord([]);
                    if (value === "") {
                        setRecord([]);
                        return [2 /*return*/];
                    }
                    handleSearch();
                    return [4 /*yield*/, ((_b = (_a = searchBasicModules === null || searchBasicModules === void 0 ? void 0 : searchBasicModules.data) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.hits)];
                case 1:
                    dataModule = _f.sent();
                    data = (_e = (_d = (_c = searchBasicModules === null || searchBasicModules === void 0 ? void 0 : searchBasicModules.data) === null || _c === void 0 ? void 0 : _c.results) === null || _d === void 0 ? void 0 : _d.hits) === null || _e === void 0 ? void 0 : _e.map(function (item) { return (__assign({}, item)); });
                    if (chips.length > 0) {
                        foundModules_1 = new Set(data.map(function (item) { return item.record_module; }));
                        allChipsExist = chips.every(function (chip) { return foundModules_1.has(chip); });
                        if (allChipsExist) {
                            data = data.filter(function (item) { return chips.includes(item.record_module); });
                        }
                        else {
                            data = [];
                        }
                    }
                    setRecord(data);
                    setTotalResultCount((dataModule === null || dataModule === void 0 ? void 0 : dataModule.length) || 0);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _f.sent();
                    console.error("Erreur lors de la récupération des données:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _q = useState(null), debounceTimer = _q[0], setDebounceTimer = _q[1];
    useEffect(function () {
        return function () {
            if (debounceTimer) {
                clearTimeout(debounceTimer);
            }
        };
    }, [debounceTimer]);
    useEffect(function () {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        var timer = setTimeout(function () {
            loadResultSearch();
        }, 500);
        setDebounceTimer(timer);
        return function () {
            if (debounceTimer) {
                clearTimeout(debounceTimer);
            }
        };
    }, [(_d = searchBasicModules === null || searchBasicModules === void 0 ? void 0 : searchBasicModules.data) === null || _d === void 0 ? void 0 : _d.results]);
    var handleKeyDown = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var modules_1, cleanedQuery;
        return __generator(this, function (_a) {
            if (e.key === "Enter" && value.trim() !== "") {
                modules_1 = value
                    .split(" ")
                    .filter(function (word) { return word.startsWith("module:"); })
                    .map(function (word) { return word.replace("module:", ""); });
                if (modules_1.length > 0) {
                    setChips(function (prevChips) {
                        var newModules = modules_1.filter(function (m) { return !prevChips.includes(m); });
                        return __spreadArray(__spreadArray([], prevChips, true), newModules, true);
                    });
                    cleanedQuery = value
                        .split(" ")
                        .filter(function (word) { return !word.startsWith("module:"); })
                        .join(" ");
                    setSearchTrigger(cleanedQuery); // Trigger search
                    setValue(cleanedQuery); // Clean input too
                }
                else {
                    setSearchTrigger(value); // Trigger search
                }
            }
            return [2 /*return*/];
        });
    }); };
    var _r = useState([]), recordAdvanced = _r[0], setRecordAdvanced = _r[1];
    var _s = useState(Object.keys(recordAdvanced || {}).reduce(function (acc, key) {
        acc[key] = 1;
        return acc;
    }, {})), paginationState = _s[0], setPaginationState = _s[1];
    var columns = [
        { header: "Module", name: "record_module" },
        {
            header: "Name",
            name: "name",
        },
        { header: "Summary", name: "summary" },
        { header: "Actions", name: "item_actions" },
        { header: "Date Entered", name: "date_entered" },
        { header: "Date Modified", name: "date_modified" },
        { header: "Score", name: "score" },
    ];
    var handleSaveSearchHistory = function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!chips)
                        return [2 /*return*/];
                    return [4 /*yield*/, saveSearchHistory({
                            body: {
                                term: searchQuery,
                                modules: chips,
                                dateCreated: moment().format("YYYY-MM-DD HH:mm:ss"),
                            },
                        }).unwrap()];
                case 1:
                    response = _c.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.recent_searches) {
                        setRecentSearch((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.recent_searches);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                handleClose();
                if (chips.length > 0 && value) {
                    handleSaveSearchHistory();
                }
            }
        }
        if (isOpenHistory) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpenHistory]);
    var handleDeleteChip = function (chipToDelete) {
        setChips(function (prev) { return prev.filter(function (chip) { return chip !== chipToDelete; }); });
    };
    return (_jsxs("div", __assign({ className: "p-3 bg-body text-[var(--colors-label)]" }, { children: [_jsxs("div", __assign({ className: "my-2 " }, { children: [_jsx(Input, { type: "text", className: "text-sm w-1/4", placeholder: "Search...", value: value, onChange: function (e) {
                            setValue(e.target.value);
                            setValue(e.target.value);
                        }, onKeyDown: function (e) {
                            if (e.key === "Enter") {
                                handleSearch();
                                handleKeyDown(e);
                            }
                        }, style: { marginRight: "0.5rem" }, endDecorator: _jsxs("div", __assign({ className: "flex items-center space-x-1" }, { children: [_jsx(FontAwesomeIcon, { icon: faSearch, className: "cursor-pointer p-1.5 shadow transition hover:scale-105 bg-gray-100  hover:text-[--colors-link] rounded  ", onClick: function () {
                                        loadResultSearch();
                                    } }), _jsx("span", { className: "border-l py-4 " }), _jsxs("section", __assign({ ref: menuRef }, { children: [_jsx(IconButton, __assign({ onClick: handleClick }, { children: _jsx(FontAwesomeIcon, { icon: faHistory, className: "px-1 cursor-pointer hover:text-[--colors-link]" }) })), _jsx(Menu, __assign({ anchorEl: anchorEl, open: isOpenHistory, onClose: handleClose, placement: "bottom-start", sx: { width: "400px" }, onMouseDown: function (event) { return event.stopPropagation(); } }, { children: _jsx(History, { dataRecentSearch: recentSearch, setInputValue: setValue, setChips: setChips }) }))] }))] })) }), _jsxs("section", __assign({ className: " pb-2 px-1 mb-4 mt-2 space-x-1" }, { children: [searchQuery && (_jsxs(Chip, __assign({ size: "sm", variant: "outlined", color: "neutral", sx: {
                                    backgroundColor: "#D3D3D340",
                                }, endDecorator: _jsx(ChipDelete, { onDelete: function () { return setValue(""); }, sx: {
                                        backgroundColor: "#D3D3D380",
                                    } }) }, { children: ["\"", searchQuery, "\""] }))), chips === null || chips === void 0 ? void 0 : chips.map(function (module, index) { return (_jsx(Chip, __assign({ size: "sm", variant: "outlined", color: "neutral", sx: {
                                    border: "1px solid ".concat(colorIcons && colorIcons[module], " "),
                                    color: "".concat(colorIcons && colorIcons[module]),
                                    backgroundColor: "".concat(colorIcons && colorIcons[module], "10"),
                                }, endDecorator: _jsx(ChipDelete, { onDelete: function () { return handleDeleteChip(module); }, sx: {
                                        color: "".concat(colorIcons && colorIcons[module], " !important"),
                                        backgroundColor: "".concat(colorIcons && colorIcons[module], "60"),
                                    } }) }, { children: module }), index)); })] }))] })), _jsxs("div", __assign({ className: "relative mt-4" }, { children: [isFetching && _jsx(LoaderImage, {}), _jsx(List, { record: record, perPage: elementPerPage, columns: columns })] }))] })));
}
widgetsDictionary.register("widget/home/searchList", {
    name: "Home dashboard",
    validation: true,
    display: SearchList,
    selectable: false,
});
